import ko from 'knockout';

/**
 * This binding is used to set video stream to the video element
 */
ko.bindingHandlers.streamSrc = {
    update: function(element, valueAccessor) {
        element.srcObject = ko.unwrap(valueAccessor());
    }
}